import { RemoteComponent } from 'mf-dynamic-remote-component';
import * as React from 'react';
import { Suspense } from 'react';
import { Spinner } from 'telia-front-react';
import { pushGaData } from '../utils';
import { DiilHeaderContext } from './DiilHeader';
import { getTeliaSelfServiceUrl, getSsoApiUrl, getBaseSelfServiceUrl } from './EnvironmentUrls';
const ActionsProvider = () => {
    const { translate, sso, environment, postLoginRedirectUrl, brand, client, languageProps } = React.useContext(DiilHeaderContext);
    const ssoModule = (ssoUrl, module) => RemoteComponent({
        path: `${ssoUrl}/js/sso-remote.js`,
        scope: 'sso',
        module
    });
    const dropdownContent = (url, tier, ssoUrl) => {
        const Application = React.lazy(() => ssoModule(ssoUrl, './App'));
        const ssoConfig = {
            brand: brand,
            apiUrl: `${ssoUrl}/api`,
            locale: languageProps.currentLanguage
        };
        return (React.createElement(Suspense, { fallback: React.createElement(Spinner, null) },
            React.createElement(Application, { initialUrl: url, config: { ...ssoConfig, env: tier, locale: languageProps.currentLanguage }, client: client })));
    };
    const getHeaderActions = () => {
        return {
            sso: { isSsoLoaded: sso.isSsoLoaded, isLoggedIn: sso.isLoggedIn },
            items: [getSsoData(), getBurgerMenu()]
        };
    };
    const getBurgerMenu = () => {
        return {
            id: 'nav',
            icon: '#menu-burger',
            url: '#',
            label: translate('header.menu'),
            location: 'bottom'
        };
    };
    const getSsoData = () => {
        const isLoggedIn = sso.isLoggedIn;
        const iframeUrl = sso.getLoginUrl(postLoginRedirectUrl);
        const webapiQueryParam = 'webapi';
        if (brand === 'super' && isLoggedIn) {
            return {
                id: 'sso',
                icon: '#contact',
                url: getBaseSelfServiceUrl(environment, brand, languageProps.currentLanguage),
                onClick: () => pushGaData({ eventAction: 'Choose segment', eventLabel: 'Iseteenindus' }),
                location: 'top',
                label: translate('header.nav.selfService')
            };
        }
        return {
            id: 'sso',
            icon: '#contact',
            url: iframeUrl.replace(`${webapiQueryParam}=true`, `${webapiQueryParam}=false`),
            onClick: (event) => {
                event.preventDefault();
                if (sso.dealer && !sso.person) {
                    window.location.href = `${getTeliaSelfServiceUrl(environment)}/teenindus/otsing`;
                }
            },
            location: 'top',
            label: getSSOLabel(isLoggedIn),
            dropdownContent: dropdownContent(dropDownUrl(), environment, `${getSsoApiUrl(environment, brand)}`),
            dropdownSize: isLoggedIn ? 'small' : 'large',
            dropdownPadding: isLoggedIn ? 'small' : 'medium',
            labelClassName: 'nls_protected'
        };
    };
    const dropDownUrl = () => {
        if (isDealerWithoutPerson()) {
            return null;
        }
        return isDealerWithPerson() ? client.getDealerMandatesUrl(true) : client.getLoginUrl(null, true);
    };
    const isDealerWithoutPerson = () => {
        return sso.dealer && !sso.person;
    };
    const isDealerWithPerson = () => {
        return sso.dealer && !!sso.person;
    };
    const getSSOLabel = (isLoggedIn) => {
        const customer = sso.customer;
        if (isLoggedIn) {
            return getDisplayName(true, customer);
        }
        return translate('sso.label');
    };
    const getDisplayName = (isMobile, customer) => {
        if (!customer) {
            return translate('sso.choose.customer');
        }
        const { displayName = '' } = customer;
        if (isMobile) {
            return displayName.split(' ').shift();
        }
        return displayName;
    };
    return { getHeaderActions, dropdownContent };
};
export default ActionsProvider;
//# sourceMappingURL=ActionsProvider.js.map